import { AnyAction } from 'redux';

import {
    CUSTOMER_DETAIL_DOCUMENTS_DELETE,
    CUSTOMER_DETAIL_DOCUMENTS_RECEIVED,
    CUSTOMER_DETAIL_DOCUMENTS_RENAME,
    CUSTOMER_DETAIL_DOCUMENTS_UPLOAD_PROGRESS,
    CUSTOMER_DETAIL_DOCUMENTS_UPLOAD_START,
    CUSTOMER_DETAIL_DOCUMENTS_UPLOAD_SUCCESS,
} from './customer-detail-documents-actions';
import { CUSTOMER_DETAIL_RESET } from '../../store/customer-detail-actions';
import { CustomerDocument } from '../models/customer-detail-document';

export interface CustomerDetailDocumentsReducerState {
    documents: CustomerDocument[];
}

const initialDocumentsReducerState: CustomerDetailDocumentsReducerState = {
    documents: [],
};

export const customerDetailDocumentsReducer = (
    state: CustomerDetailDocumentsReducerState = initialDocumentsReducerState,
    action: AnyAction
): CustomerDetailDocumentsReducerState => {
    switch (action.type) {
        case CUSTOMER_DETAIL_RESET: {
            return initialDocumentsReducerState;
        }

        case CUSTOMER_DETAIL_DOCUMENTS_RECEIVED: {
            return {
                ...state,
                documents: action['customerDocuments'],
            };
        }

        case CUSTOMER_DETAIL_DOCUMENTS_RENAME: {
            const index = state.documents.findIndex(document => document.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextDocuments = [...state.documents];
            nextDocuments[index] = { ...nextDocuments[index], title: action['title'] };
            return { ...state, documents: nextDocuments };
        }

        case CUSTOMER_DETAIL_DOCUMENTS_DELETE: {
            return {
                ...state,
                documents: state.documents.filter(document => document.id !== action['id']),
            };
        }

        case CUSTOMER_DETAIL_DOCUMENTS_UPLOAD_START: {
            return {
                ...state,
                documents: [...state.documents, action['document']],
            };
        }

        case CUSTOMER_DETAIL_DOCUMENTS_UPLOAD_PROGRESS: {
            const index = state.documents.findIndex(document => document.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextDocuments = [...state.documents];
            nextDocuments[index] = { ...nextDocuments[index], uploadProgress: action['progress'] };
            return {
                ...state,
                documents: nextDocuments,
            };
        }

        case CUSTOMER_DETAIL_DOCUMENTS_UPLOAD_SUCCESS: {
            const index = state.documents.findIndex(document => document.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextDocuments = [...state.documents];
            nextDocuments[index] = { ...action['document'], uploadProgress: undefined };
            return {
                ...state,
                documents: nextDocuments,
            };
        }

        default: {
            return state;
        }
    }
};
